import {RequestAxios} from "../../index";
import {ZonesOfClub} from "./interfaces";
import {API_START} from "../../constants";

export const getZonesOfClubList = async (guid: string) => {
    const zonesUrl = `${API_START}/client/stores/${guid}/store_zones`;
    return await RequestAxios.get<ZonesOfClub[]>(zonesUrl)
}